export default {
      id: "as-seat-available-usage",
      viewBox: "0 0 56 56",
      url: "/" + "sprite.svg#as-seat-available",
      toString: function () {
        return this.url;
      }
    }